export default "__VITE_ASSET__D0pz8o7J__"